<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>
<script>
(function (para) {
  // eslint-disable-next-line one-var
  var p = para.sdk_url,
    n = para.name,
    w = window,
    d = document,
    s = 'script',
    x = null,
    y = null
  if (typeof w['sensorsDataAnalytic201505'] !== 'undefined') {
    return false
  }
  w['sensorsDataAnalytic201505'] = n
  w[n] =
    w[n] ||
    function (a) {
      return function () {
        (w[n]._q = w[n]._q || []).push([a, arguments]);
      }
    }
  var ifs = [
    'track',
    'quick',
    'register',
    'registerPage',
    'registerOnce',
    'clearAllRegister',
    'trackSignup',
    'trackAbtest',
    'setProfile',
    'setOnceProfile',
    'appendProfile',
    'incrementProfile',
    'deleteProfile',
    'unsetProfile',
    'identify',
    'login',
    'logout',
    'trackLink',
    'deleteItem',
    'setItem',
    'trackCustom',
    'initError'
  ]
  for (var i = 0; i < ifs.length; i++) {
    w[n][ifs[i]] = w[n].call(null, ifs[i]);
  }
  if (!w[n]._t) {
    // eslint-disable-next-line no-sequences,no-unused-expressions
    (x = d.createElement(s)), (y = d.getElementsByTagName(s)[0])
    x.async = 1
    x.src = p
    x.setAttribute('charset', 'UTF-8')
    w[n].para = para
    y.parentNode.insertBefore(x, y)
  }
})({
  sdk_url: '../static/H5_FireFly_JS_SDK.min.js',
  name: 'sensors',
  server_url: 'https://firefly.abchina.com.cn/firefly-collection/Collect/MobileData',
  js_error: true,
  show_log: true,
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  app_js_bridge: true, // 配置H5与APP打通，如果H5工程集成在APP中，推荐开启
  firefly_apc_type: 1, // H5默认1，必传项
  firefly_system_number: 'bc3a5819-a189-40e0-95de-ca2baaf2410b',
  firefly_model_name: '江苏_城市专区_苏州共享雨伞', // 接入方模块名称，必传项
  heatmap: {
    // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    clickmap: 'not_collect',
    collect_tags: {
      div: {
        max_level: 3 // 默认是 1，即只支持叶子 div。可配置范围是 [1, 2, 3],非该范围配置值，会被当作 1 处理
      }
    }
  }
})
export default {
  name: 'App',
  activated () {
  }
}

</script>
<style>
  html, body, #app {
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue